module.exports = __webpack_public_path__ + "static/2011-52cc8651ebcfed68b5e149a4eee6f662.webp";